<template>
  <base-dialog
    max-width="600"
    min-width="650"
    v-model="show"
    @close="close"
    :loading="loading"
  >
    <template v-slot:title> {{ title }} </template>
    <template #content>
      <div :class="{ 'overflow-auto': isMobile }">
        <v-data-table
          :headers="headers"
          :items="items"
          fixed-header
          show-select
          v-model="selected"
          hide-default-footer
          item-key="name"
          :height="isMobile ? '100%' : '50vh'"
        ></v-data-table>
      </div>
    </template>
    <template #extra-btn>
      <base-button color="primary" @click="submit()">
        Cập nhật
      </base-button>
    </template>
  </base-dialog>
</template>

<script>
import { EDIT_TYPE } from '@constant'
import { API_LAYER } from '@service/api'
export default {
  props: {},
  data: () => ({
    show: false,
    loading: false,
    typeEdit: EDIT_TYPE.CREATE,
    form: {},
    selected: [],
    nameSelect: [],
    headers: [
      {
        text: 'Thuộc tính',
        align: 'start',
        value: 'name',
      },
      {
        text: 'Kiểu dữ liệu',
        align: 'start',
        value: 'binding',
      },
    ],
    items: [],
    id: null,
  }),
  computed: {
    isDetail() {
      return this.typeEdit == EDIT_TYPE.DETAIL
    },
    isCreate() {
      return this.typeEdit == EDIT_TYPE.CREATE
    },
    isUpdate() {
      return this.typeEdit == EDIT_TYPE.UPDATE
    },
    title() {
      if (this.typeEdit == EDIT_TYPE.CREATE) {
        return this.$t('actions.create')
      } else if (this.typeEdit == EDIT_TYPE.DETAIL) {
        return this.$t('actions.detail')
      } else {
        return this.$t('actions.update')
      }
    },
  },
  methods: {
    open(data, type = EDIT_TYPE.DETAIL) {
      this.selected = []
      this.typeEdit = type
      this.show = true
      this.form = Object.assign({}, data || {})
      this.loading = true
      API_LAYER.getFeatureType(data.id).then((res) => {
        this.items = res.data.attributes.filter(
          (item) => item.name != 'the_geom'
        )
        this.loading = false
        if (data.show_fields) {
          JSON.parse(data.show_fields).forEach((value) => {
            this.selected.push(this.items.find((item) => item.name == value))
          })
        }
      })
      this.id = data.id
    },
    close() {
      this.show = false
      this.loading = false
      this.form = {}
    },
    submit() {
      this.nameSelect = this.selected.map((x) => x.name)
      try {
        API_LAYER.setInfor({ fields: this.nameSelect }, this.id)
        this.$emit('reset')
        this.show = false
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped></style>
